import type { ButtonProps } from 'src/components/atoms';
import { StyledIconInButton } from 'src/components/foundations/foundations.styles';
import { StyledBackButton } from './CaseScreenBackButton.styles';

export interface CaseScreenBackButtonProps {
  onClick: () => void;
  size?: NonNullable<ButtonProps['size']>;
  variant?: NonNullable<ButtonProps['variant']>;
  'data-testid'?: string;
}

export const CaseScreenBackButton = ({
  onClick,
  size = 'small',
  variant = 'secondary',
  'data-testid': dataTestId = 'case-screen-back-button',
}: CaseScreenBackButtonProps) => (
  <StyledBackButton
    size={size}
    variant={variant}
    onClick={onClick}
    data-testid={dataTestId}
  >
    <StyledIconInButton
      size="small"
      position="left"
      className="uil uil-angle-left-b"
    />
    Back
  </StyledBackButton>
);
